var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4297_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16Z",
    fill: "#0A0B0D",
    stroke: "#464B55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92525 19.7681C10.0354 19.6581 10.1847 19.5962 10.3404 19.5962H24.7057C24.9674 19.5962 25.0984 19.9127 24.9133 20.0977L22.0748 22.934C21.9646 23.044 21.8153 23.1058 21.6596 23.1058H7.29426C7.03257 23.1058 6.90157 22.7894 7.08669 22.6044L9.92525 19.7681Z",
    fill: "url(#paint0_linear_4297_1406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92525 9.17186C10.0354 9.06182 10.1847 9 10.3404 9H24.7057C24.9674 9 25.0984 9.31644 24.9133 9.50142L22.0748 12.3377C21.9646 12.4478 21.8153 12.5096 21.6596 12.5096H7.29426C7.03257 12.5096 6.90157 12.1931 7.08669 12.0082L9.92525 9.17186Z",
    fill: "url(#paint1_linear_4297_1406)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0748 14.4362C21.9646 14.3262 21.8153 14.2644 21.6596 14.2644H7.29426C7.03257 14.2644 6.90157 14.5808 7.08669 14.7658L9.92525 17.6021C10.0354 17.7121 10.1847 17.774 10.3404 17.774H24.7057C24.9674 17.774 25.0984 17.4575 24.9133 17.2725L22.0748 14.4362Z",
    fill: "url(#paint2_linear_4297_1406)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4297_1406",
    x1: 19.1691,
    y1: 5.13069,
    x2: 9.22703,
    y2: 24.1737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#7884D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4297_1406",
    x1: 19.1691,
    y1: 5.13069,
    x2: 9.22703,
    y2: 24.1737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#7884D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4297_1406",
    x1: 19.1691,
    y1: 5.13069,
    x2: 9.22703,
    y2: 24.1737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#7884D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4297_1406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/Solana.0b16efd59dcbd77a537ae77f225ad1a2.svg";
export { ForwardRef as ReactComponent };